import { styled } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import * as React from "react";


const useStyles = makeStyles({
  spinner: {
    animation: "$spin 1s linear infinite",
    transformOrigin: "center",
  },
  "@keyframes spin": {
    to: {
      transform: "rotate(360deg)",
    },
  },
});

const ProgressActivityIcon = (props) => {
  const classes = useStyles();
  return (
    <svg
      className={classes.spinner}
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#1A1A1A"
      {...props}
    >
      <path d="M325-111.5q-73-31.5-127.5-86t-86-127.5Q80-398 80-480.5t31.5-155q31.5-72.5 86-127t127.5-86Q398-880 480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480.5-80Q398-80 325-111.5Z" />
    </svg>
  )
};
export default ProgressActivityIcon;
